<div class="operations">
  @for (action of actions; track action.id) {
    @if (action.copy_step?.operation_step_type !== 'edit_selected_copy') {
      <app-menu-group-button
        [matTooltip]="action.$$toolTip"
        [matTooltipDisabled]="false"
        [disabled]="disabled"
        [readonly]="action.$$disabled || !action.read_access && readonly"
        (itemClick)="onActionClick($event)"
        [item]="action"
        [isAgent]="artifact?.object_type === 'agent'"
      ></app-menu-group-button>
    }
  }
</div>
